export default ({ signup }, _, { t }) => {
  if (signup) {
    return `${t('signup_join_flipboard')} | ${t('sign_up_and_create')}`;
  }
};
